module.exports = __webpack_public_path__ + "static/img/034_TO8_1495.36133cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/034_TO8_1495.jpg
// module id = fPXU
// module chunks = 0